import {createAsyncThunk} from '@reduxjs/toolkit';

import {
    fetchOpenInterface,
    TFetchOpenInterfaceParams,
    clearStage,
    TClearStageParams,
} from './external-loading-api';
import {EXTERNAL_LOADING_SLICE} from './external-loading-constants';

export const loadOpenInterface = createAsyncThunk<
  any,
  TFetchOpenInterfaceParams
>(
    `${EXTERNAL_LOADING_SLICE}/loadOpenInterface`,
    async (arg, {rejectWithValue}) => {
        try {
            const response = await fetchOpenInterface(arg ?? undefined);
            const {data} = response;
            return data;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);

export const clearStageThunk = createAsyncThunk<void, TClearStageParams>(
    `${EXTERNAL_LOADING_SLICE}/clearStage`,
    async (arg, {rejectWithValue}) => {
        try {
            await clearStage(arg);
            return undefined;
        } catch (e) {
            return rejectWithValue(e);
        }
    },
);
